import * as React from 'react';

import './tab-order.styles.scss';

export type TabOrderProps = {
  value: number;
  onClick?: () => void;
};

export const TabOrder: React.FC<TabOrderProps> = ({ value, onClick }) => (
  <div
    className={"DatasheetsEditorDatasheetTabOrder"}
    onClick={onClick}
    style={onClick ? { cursor: 'pointer' } : undefined}
  >
    {value}
  </div>
);